import styled from 'styled-components'

export const AboutContainer = styled.section`
  padding: 40px 5%;
  background-color: rgb(255, 255, 255);
  text-align: center;
`

export const Title = styled.h2`
  font-family: Poppins;
  font-weight: bold;
  font-size: 3.5rem;
  color: #fa8c16;
  margin-bottom: 40px;
  @media (max-width: 720px) {
    font-size: 2rem;
  }
`

export const InfoContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`

export const InfoCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 350px;
  height: 200px;
  border-radius: 9.61px;
  background-color: #e6e6e6;
  padding: 1.5rem;

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }

  p {
    font-family: Poppins;
    font-size: 16px;
  }

  @media (max-width: 1200px) {
    width: 350px;
    height: 260px;
  }

  @media (max-width: 720px) {
    display: flex;
    justify-content: center;
    text-align: start;
    width: 280px;
    height: 240px;
    border-radius: 0;
  }
`

export const Image = styled.img`
  height: 32px;
  max-width: 200px;
`

export const Link = styled.a`
  font-family: Poppins;
  display: inline-flex;
  font-size: 1rem;
  color: #007bff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  svg {
    margin-left: 8px;
  }
`
